"use strict";var u=Object.defineProperty;var i=Object.getOwnPropertySymbols;var a=Object.prototype.hasOwnProperty,d=Object.prototype.propertyIsEnumerable;var n=(o,e,s)=>e in o?u(o,e,{enumerable:!0,configurable:!0,writable:!0,value:s}):o[e]=s,r=(o,e)=>{for(var s in e||(e={}))a.call(e,s)&&n(o,s,e[s]);if(i)for(var s of i(e))d.call(e,s)&&n(o,s,e[s]);return o};Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("../assets/jsx-runtime-d00224a6.js"),c=require("@tencent/tcb-component"),l=require("../assets/emotion-css.esm-0efbe865.js");require("react");function b(o){return t.jsxRuntimeExports.jsxs("div",{className:p,children:[t.jsxRuntimeExports.jsx("div",{className:"cop-buy-sdk-overlay"}),t.jsxRuntimeExports.jsx(c.BuyLoading,r({className:"cop-buy-sdk-buy-loading"},o))]})}const p=l.css`
  width: 100%;
  height: 100%;
  .cop-buy-sdk-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.01);
    z-index: 999
  }
  .cop-buy-sdk-buy-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1000;
  }
`;exports.Loading=b;
